import { getCameraImages } from "../components/api/camArchive";

const initialState = {
    cams:{},
    activeCamera: null,
    images:{},
    rangeValues:{},
    rangeSettings:{},
    cameraInterval:{},
    dateSelected:{},
    weatherData:{},
    addressData:{},
    isSliderPlayings:{},
    isFade: true,
    redDot:false,
    isSidebar: false
};

export default function webcamReducer(state = initialState, action) {
    switch (action.type) {
        case "LOAD_WEBCAMS":
            return {
                ...state,
                cams: action.payload
            };
        case "SET_ACTIVE_CAMERA":
            return {
                ...state,
                activeCamera: action.payload.replace('ordered','')
            };
        case "SET_IMAGES":
            state.images['cam'+action.camid] = action.imgs;
            return {
                ...state,
                images: {...state.images}
            };  
        case "SET_RANGE_VALUES":
            state.rangeValues['cam'+action.camid] = action.values;
            var today = new Date();
            var redDot;
            if(state.activeCamera === action.camid){
                if(state.cameraInterval['cam' + action.camid] === 'daily'
                    && state.dateSelected['cam' + state.activeCamera].getDate() === today.getDate()
                    && state.dateSelected['cam' + state.activeCamera].getMonth() === today.getMonth()
                    && state.dateSelected['cam' + state.activeCamera].getFullYear() === today.getFullYear()
                    && parseInt(state.rangeValues['cam' + state.activeCamera]) === parseInt(state.rangeSettings['cam' + state.activeCamera]['max'])){
                    state.redDot = true;
                } else {
                    state.redDot = false;
                }
            }
            return {
                ...state,
                rangeValues: {...state.rangeValues}
            };   
        case "SET_RANGE_SETTINGS":
            state.rangeSettings['cam'+action.camid] = action.setting;
            return {
                ...state,
                rangeSettings: {...state.rangeSettings}
            }; 
        case "SET_CAMERA_INTERVAL":
            state.cameraInterval['cam'+action.camid] = action.values;
            if(action.values !== 'daily'){
                getCameraImages(action.dispatch, state.cams['ordered' + action.camid], action.values);
            }
            return {
                ...state,
                cameraInterval: {...state.cameraInterval}
            };
        case "SET_DATE_SELECTED":
            var old_date = state.dateSelected['cam' + action.camid] ? state.dateSelected['cam' + action.camid] : null;
            state.dateSelected['cam' + action.camid] = action.selected_date;
            //console.log('state.cams',state.cams);
            //dispatch(setDateSelected({ ...dateSelected }));
            if(old_date && old_date.getTime() !== action.selected_date.getTime()){ //we need to fetch images of the selected date for current camera
                getCameraImages(action.dispatch, state.cams['ordered' + action.camid], 'daily', action.selected_date);
            }
            return {
                ...state,
                dateSelected: {...state.dateSelected}
            };
        case "SET_WEATHER_DATA":
            state.weatherData['cam'+action.camid] = action.data;
            return {
                ...state,
                weatherData: {...state.weatherData}
            }; 
        case "SET_ADDRESS_DATA":
            state.addressData['cam'+action.camid] = action.data;
            return {
                ...state,
                addressData: {...state.addressData}
            };   
        case "SET_IS_SLIDER_PLAYINGS":            
            state.isSliderPlayings['cam'+action.camid] = action.isPlaying;
            if(!state.isSliderPlayings['cam'+action.camid]
                && state.cameraInterval['cam'+action.camid] === 'daily'
                && state.images['cam'+action.camid].length-1 === state.rangeValues['cam'+action.camid]){ 
                //is playing and interval=daily and is last image
                //find the 5am image for this webcam
                let fiveAMIndex = state.images['cam'+action.camid].findIndex(obj => obj.originalTitle === '5:00');
                if(!fiveAMIndex) fiveAMIndex = state.images['cam'+action.camid].findIndex(obj => obj.originalTitle === '5:15');
                if(!fiveAMIndex) fiveAMIndex = state.images['cam'+action.camid].findIndex(obj => obj.originalTitle === '5:30');

                //console.log('5am at key', fiveAMIndex);
                if(fiveAMIndex){
                    state.redDot = false;
                    state.rangeValues['cam'+action.camid] = fiveAMIndex;
                    action.galleryRef.slideToIndex(fiveAMIndex);
                }
            }
            return {
                ...state,
                isSliderPlayings: {...state.isSliderPlayings},
                rangeValues: {...state.rangeValues}
            }; 
        case "SET_IS_FADE":
            return {
                ...state,
                isFade: action.payload
            };
        case "SET_IS_SIDEBAR":
            return {
                ...state,
                isSidebar: action.payload
            };    
        default:
            return state;
    }
}